import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  FDEmphasisSurface, FDBodyText, FDSecondaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import { useDataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('Disclosure', (theme) => ({
  inner: {
    // Need custom CSS to achieve the special link color that looks better on this background
    '& a': {
      color: theme.palette.facet.orange,
    },
    padding: theme.spacing(2, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  content: {
    '& > * > *': {
      // Need custom CSS to achieve this custom color that looks better on this background
      color: theme.palette.facet.oceana200,
    },
  },
  unpaddedButton: {
    '& > *': {
      padding: '0 !important', // Must be !important to override MUI
      height: 'unset !important', // Must be !important to override MUI
    },
  },
  invisibleSpacer: {
    visibility: 'hidden',
  },
}));

export function Disclosure({
  title, content, onClose, ...rest
}) {
  const classes = useStyles();
  const closeButton = onClose ? (
    <div className={classes.unpaddedButton}>
      <FDSecondaryActionIconButton size="lg" alignSelf="center" icon="close" label="Close" onClick={onClose} />
    </div>
  ) : null;
  return (
    <FDEmphasisSurface rounded={false} {...useDataAttrs(rest)}>
      <div className={classes.inner}>
        {onClose ? (
          <FDStack direction="row" spacing={2} justifyContent="space-between">
            <div className={classes.invisibleSpacer}>{closeButton}</div>
            <FDBodyText value={title} size="lg" align="center" />
            {closeButton}
          </FDStack>
        ) : (
          <FDBodyText value={title} size="lg" align="center" />
        )}
        <div className={classes.content}>
          <FDBodyText value={content} color="textDisabled" size="sm" align="center" />
        </div>
      </div>
    </FDEmphasisSurface>
  );
}

Disclosure.propTypes = {
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  onClose: PropTypes.func,
};

Disclosure.defaultProps = {
  onClose: undefined,
};
